
import { telemetry } from '../../../@vendor/Posthog';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { EditorSession } from '../../canvas/EditorSession';
import { ProfileModel } from '../../ProfileModel';
import { AutoSpotlightInfo } from './SpotlightProperties';

export const spotlightUser = defineCommand(
    'spotlightUser',
    'Spotlight: User...',
    (r, [userId, mode]: [string?, string?]) => {

        const session = r.call(EditorSession);

        const safeUser = userId || '';
        const safeMode = mode === 'votes' ? mode : 'objects';
        session.update(AutoSpotlightInfo, AutoSpotlightInfo.create(!!safeUser, safeUser, safeMode));
        telemetry.emit('interaction.spotlight');
    }
);

export const spotlightToggleSelf = defineCommand(
    'spotlightToggleSelf',
    'Spotlight: Toggle Self',
    r => {

        const me = r.call(ProfileModel);
        const session = r.call(EditorSession);

        const current = session.get(AutoSpotlightInfo);
        if (current.enabled && current.target === me.id) {
            session.update(AutoSpotlightInfo, AutoSpotlightInfo.create(false));
        }
        else {
            session.update(AutoSpotlightInfo, AutoSpotlightInfo.create(true, me.id, current.mode ?? 'objects'));
        }
    }
);

export const inSpotlightCommands = () => inCommands(
    spotlightUser,
);

